<template>
  <div class="aboutList">
    <el-table :data="tableData.list" @row-click="anojump" style="width: calc(100% - 32px); fontsize: 14px" >
      <el-table-column prop="corplogo_cn" label="Company Logo">
        <template slot-scope="scope">
          <img class="boxLogo" :src="scope.row.corplogo_cn" />
        </template>
      </el-table-column>
      <el-table-column prop="corpname_en" label="Exhibitor Name" width="230" align="left">
      </el-table-column>
      <el-table-column prop="booth" label="Hall/Booth Number"> </el-table-column>
      <el-table-column prop="exrange_en" label="Product Categories" width="220" align="left">

      </el-table-column>

      <el-table-column prop="amend" label="Operate">
        <template slot-scope="scope">
          <div @click.stop>
            <el-popconfirm
              confirm-button-text="Confirm" 
              cancel-button-text="Cancel"
              title="Are you sure to cancel?"
              @onConfirm='cancel(scope)'
            >
              <el-button slot="reference">{{name}}</el-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <el-pagination
      v-if="tableData.listnum>tableData.pagelistnum"
      @current-change="handleCurrentChange"
      :current-page="tableData.pagelistnum"
      :page-size="tableData.pagelistnum"
      layout="total, prev, pager, next "
      :pager-count="5"
      prev-text="prev"
      next-text="next"
      :total="tableData.listnum * 1"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props:["tableData", "name"],
  data() {
    return {
      visible:false
    }
  },
  methods: {
    handleCurrentChange(a){//当前页改变时
      // 调用请求接口
      this.$emit("init",a)
    },
    anojump(row){//详情 
      if (this.jump(this)) {
        this.$router.push('/exhibitor/details/'+row.offid+"/"+row.ocid)
      }
    },
    cancel(scope){//取消收藏
      this.$emit('isCollect',scope.row.ocid)
      this.visible = false
    },
  },
    
  }
</script>

<style scoped>
  .aboutList >>>.el-table--fit{
    margin: 0 16px 8px;
    width: calc(100% - 32px);
    box-sizing: border-box;
  }
  .aboutList>>>.el-table thead{
    line-height: 62px;
    /* color: #000 */
  }
  .aboutList>>>.el-table th>.cell{
    font-family: 'FjallaOne-Regular';
  }
  .aboutList >>>.el-table td, .aboutList >>>.el-table th.is-leaf{
    text-align: center;
  }
  .aboutList>>>.el-table td,.aboutList>>>.el-table th{
    padding: 0;
  }
  .aboutList >>>.el-table__row{
    height: 100px;
    cursor: pointer;
  }
  .boxLogo{
    max-height: 53px;
    max-width: 166px;
  }
  .range{
    max-width: 166px;
    max-height: 30px;
  }
  .aboutList>>>.el-pagination{
    padding: 30px 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .aboutList>>>.el-dialog,
  .aboutList>>>.el-pager li,
  .aboutList>>>.el-pagination,
  .aboutList>>>.el-pagination .btn-next,
  .aboutList>>>.el-pagination .btn-prev,
  .aboutList>>>.el-pagination button:disabled{
    background: none;
  }
  .aboutList>>>.el-input__icon{
    line-height: 1;
  }
  .buttonBlock{
    display: block;
    margin: 7px auto;
    width: 60px;
    height: 30px;
    background-color: red;
    color: white;
    font-weight: 600;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    outline: none;
  }
  .buttonBlock:hover{
    background-color: #f08300;
  }
  .aboutList>>>.el-popconfirm{
    outline: none;
  }
</style>